import { render, staticRenderFns } from "./khzl.vue?vue&type=template&id=0679aad0&"
import script from "./khzl.vue?vue&type=script&lang=js&"
export * from "./khzl.vue?vue&type=script&lang=js&"
import style0 from "./khzl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports